import Base from './base';

class AdminExport extends Base {
  getAdminExportData = (payload) => {
    return this.apiClient.get('admin/admin-issuer-report', payload);
  };

  downloadAdminExportXlsx = (payload) => {
    return this.apiClient.download('admin/admin-issuer-export-xlsx', payload);
  };
}

export default AdminExport;
